export default class EnteteImpressionHelperController {
	constructor() {}

	close() {
		this.modalInstance.dismiss('close');
	}
}
